import { isElement } from '../utils';

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);

import scrollLock from 'scroll-lock';

let currentPoster = null;
let nextPoster = null;
let fixedEl = null;

function matchesTrigger(el) {
	const selectors = ['[data-fs-landing-transition-trigger]'];
	return selectors.some((selector) => el.matches(selector));
}

export default {
	name: 'film-series',
	from: {
		custom: ({ current, next, trigger }) => {
			return isElement(trigger) && matchesTrigger(trigger);
		},
	},
	to: {
		namespace: ['template-film-series-single'],
	},
	before({ current, next, trigger }) {
		return new Promise((resolve) => {
			// Hide Headerbar
			if (document.body.classList.contains('has-menu-sticky')) {
				document.body.classList.remove('has-scrolled', 'has-menu-sticky');
			}

			scrollLock.disablePageScroll();

			// Fade out all elements but the trailer
			const header = current.container.querySelector('.c-header');
			const texts = current.container.querySelectorAll('[data-fs-landing-trailer-content-texts]');
			const carousel = current.container.querySelector('[data-fs-landing-film-thumbnails]');

			currentPoster = current.container.querySelector('[data-fs-landing-active-trailer]');
			gsap.to([header, texts, carousel], {
				autoAlpha: 0,
				pointerEvents: 'none',
				duration: 0.5,
				ease: 'none',
				onComplete: () => {
					let currentPosterRect = currentPoster.getBoundingClientRect();

					fixedEl = document.createElement('div');
					gsap.set(fixedEl, {
						position: 'fixed',
						zIndex: 999,
						width: currentPosterRect.width + 'px',
						height: currentPosterRect.height + 'px',
						left: currentPosterRect.left + 'px',
						top: currentPosterRect.top + 'px',
						pointerEvents: 'none',
					});

					document.body.appendChild(fixedEl);
					fixedEl.appendChild(currentPoster);

					resolve();
				},
			});
		});
	},
	leave({ current, next, trigger }) {
		return new Promise((resolve) => {
			gsap.set(current.container, {
				autoAlpha: 0,
				position: 'absolute',
			});

			gsap.set(window, {
				scrollTo: {
					y: 0,
				},
			});

			gsap.set(fixedEl, {
				zIndex: -1,
			});

			gsap.set(next.container, {
				background: 'transparent',
				opacity: 0,
			});

			resolve();
		});
	},
	beforeEnter({ current, next, trigger }) {
		return new Promise((resolve) => {
			nextPoster = next.container.querySelector('[data-fs-single-video-poster]');
			const nextPosterRect = nextPoster.getBoundingClientRect();
			nextPoster.innerHTML = '';

			gsap.to(fixedEl, {
				width: nextPosterRect.width + 'px',
				height: nextPosterRect.height + 'px',
				top: nextPosterRect.top + 'px',
				left: nextPosterRect.left + 'px',

				duration: 1.5,
				ease: 'sine.inOut',
				onComplete: () => {
					gsap.to(next.container, {
						opacity: 1,

						duration: 0.5,
						ease: 'none',
						onComplete: () => {
							nextPoster.appendChild(currentPoster);
							fixedEl.remove();

							gsap.set(next.container, {
								background: 'black',
							});

							scrollLock.enablePageScroll();

							resolve();
						},
					});
				},
			});
		});
	},
};
